import { Pencil, User } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/context/auth-context';
import { usePermissions } from '@/hooks/use-permissions';

const SELLER_EDIT_PERMISSION = 'commercial:proposals:change_seller';

interface ResumeSellerSectionProps {
  sellerName?: string;
  sellerId?: string;
  onEditSeller?: () => void;
}

export function ResumeSellerSection({
  sellerName,
  sellerId,
  onEditSeller,
}: ResumeSellerSectionProps) {
  const { user } = useAuth();
  const { hasPermission } = usePermissions();

  const canEditSeller = hasPermission(SELLER_EDIT_PERMISSION);
  const displayName = sellerName ?? user?.name ?? '-';
  const displayEmail = sellerId === user?.id && user ? user.email : undefined;

  return (
    <section className="flex items-center gap-3 rounded-xl border border-gray-200/80 bg-white px-5 py-3.5 shadow-[0_1px_2px_rgba(0,0,0,0.04),0_6px_16px_-6px_rgba(15,23,42,0.08)]">
      <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-blue-50">
        <User className="h-5 w-5 text-blue-600" />
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-[11px] font-semibold uppercase tracking-wide text-gray-500">
          Vendedor responsável
        </p>
        <div className="flex items-center gap-2">
          <span className="truncate text-sm font-bold text-gray-950">{displayName}</span>
          {displayEmail && (
            <span className="truncate text-xs text-muted-foreground">({displayEmail})</span>
          )}
        </div>
      </div>
      {canEditSeller && onEditSeller && (
        <Button
          variant="ghost"
          size="icon"
          className="h-8 w-8 shrink-0 text-gray-400 hover:text-gray-700"
          onClick={onEditSeller}
          aria-label="Editar vendedor"
        >
          <Pencil className="h-4 w-4" />
        </Button>
      )}
    </section>
  );
}
